import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from '@improver/components/buttons';
import { LabelComponent } from '@improver/components/labels';
import {
  MODALS_CONFIG,
  MODAL_REF,
  ModalBodyComponent,
  ModalFooterComponent,
  ModalHeaderComponent,
  ModalRef,
} from '@improver/components/modals';
import { OptionComponent } from '@improver/components/option';
import { SelectCustomComponent } from '@improver/components/select';
import { SelectOption } from '@improver/core';
import { V4ComapanyEmployee, V4CompanyService } from '@improver/people/people-data-layer/v4-company';
import { TranslateModule } from '@ngx-translate/core';
import { take, tap, withLatestFrom } from 'rxjs/operators';
import { V4_COMAPNY_MODAL_CONFIG } from './v4-company-modal.constants';

@Component({
  selector: 'app-v4-company-modal',
  templateUrl: './v4-company-modal.component.html',
  providers: [{ provide: MODALS_CONFIG, useValue: V4_COMAPNY_MODAL_CONFIG }],
  imports: [
    OptionComponent,
    SelectCustomComponent,
    LabelComponent,
    ButtonComponent,
    TranslateModule,
    ReactiveFormsModule,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
  ],
})
export class V4CompanyModalComponent implements OnInit {
  options: SelectOption<number, V4ComapanyEmployee>[];
  readonly companySelect: FormControl = new FormControl(null);

  constructor(
    @Inject(MODAL_REF) private modalRef: ModalRef,
    private v4CompanyService: V4CompanyService
  ) {}

  ngOnInit() {
    this.v4CompanyService
      .getCompanyEmployees()
      .pipe(
        withLatestFrom(this.v4CompanyService.getSelectedCompanyEmployee()),
        tap(([v4CompanyEmployees, selectedCompany]: [V4ComapanyEmployee[], V4ComapanyEmployee]) => {
          this.setOptions(v4CompanyEmployees);
          this.companySelect.setValue(selectedCompany?.companyEmployeeId);
        }),
        take(1)
      )
      .subscribe();
  }

  close() {
    this.modalRef.close();
  }

  linkWithV4() {
    const selectedCompanyEmployee: SelectOption<number, V4ComapanyEmployee> = this.options.find(
      (companyEmployee: SelectOption<number, V4ComapanyEmployee>) => companyEmployee.value === this.companySelect.value
    );

    this.v4CompanyService.setSelectedCompanyEmployee(selectedCompanyEmployee?.rawValue);
    this.close();
  }

  private setOptions(companyEmployees: V4ComapanyEmployee[]) {
    this.options = companyEmployees.map((companyEmployee: V4ComapanyEmployee) => ({
      value: companyEmployee.companyEmployeeId,
      label: `${companyEmployee.companyName} (${companyEmployee.organizationNumber})`,
      rawValue: companyEmployee,
    }));
  }
}
